import React, {useEffect, useMemo, useRef, useState} from "react";
import {useSelector} from "react-redux";

export default function CurriculumIndex({activeTab,setActiveTab}){
    const [isIndexVisible, setIsIndexVisible] = useState(false); // Filter visibility state

    const curriculumFileListData = useSelector((state) => state.webSetting.curriculumFileListData);
    const indexRef = useRef();

    const handleOutsideClick = (e) => {
        if (indexRef.current && !indexRef.current.contains(e.target)) {
            setIsIndexVisible(false);
        }
    };

    useEffect(() => {
        if (isIndexVisible) {
            document.addEventListener("mousedown", handleOutsideClick);
        } else {
            document.removeEventListener("mousedown", handleOutsideClick);
        }

        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [isIndexVisible]);

    const toggleIndexVisibility = () => {
        setIsIndexVisible(!isIndexVisible);
    };

    const closeIndex = () => {
        setIsIndexVisible(false);
    };

    const { curriculumFlipbookContent, curriculumOtherContent } = useMemo(() => {
        const flipbook = {};
        const otherContent = [];

        curriculumFileListData.forEach((res) => {
            if (res.type === 'flipbook') {
                flipbook[res.flipbook_code] = flipbook[res.flipbook_code] || [];
                flipbook[res.flipbook_code].push(res);
            } else {
                otherContent.push(res);
            }
        });

        return {
            curriculumFlipbookContent: flipbook,
            curriculumOtherContent: otherContent,
        };
    }, [curriculumFileListData]);

    const allContent = [
        ...Object.values(curriculumFlipbookContent),
        ...curriculumOtherContent,
    ];
console.log(allContent,'allContent')
    return (
        <>
            <div className="filter-button-container fixed top-32 left-4 sm:bottom-6 sm:right-6 md:bottom-8 md:right-8 lg:static z-50">
                <button className="filter-button bg-blue-500 text-white p-2 md:px-4 md:py-2 rounded-full md:rounded text-sm md:text-base" onClick={toggleIndexVisibility}>
                    Index
                </button>
            </div>
            {isIndexVisible && <div className="overlay" onClick={closeIndex}></div>}
            <div className={`curriculum-index ${isIndexVisible ? 'visible' : ''}`} ref={indexRef}>
                <button className="close-button" onClick={closeIndex}>X</button>
                <div className="side-panel">
                    <ul className="space-y-4">
                        <h1 className='font-bold text-xl'>Index :</h1>
                        {allContent.map((value, index) => (
                            <li
                                key={index}
                                className={`cursor-pointer ${activeTab === index ? 'font-semibold text-blue-600' : 'text-gray-600'}`}
                                onClick={() => setActiveTab(index)}
                            >
                                {value.length > 0 && value[0]?.name}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    );
}
